import { StyledTextField, styledTextFieldClasses, ActionPanelContainer } from "./HyroTextField.styles";
import React, { useEffect } from "react";
import FieldCopy from "src/components/widgets/FieldCopyPaste/FieldCopy";
import { useTheme, CircularProgress, Stack } from "@mui/material";
import { LAYOUTS, TYPES } from "src/components/widgets/FieldCopyPaste/CopyPaste.consts";
import { StyledIconButton } from "src/components/widgets/FieldCopyPaste/CopyPaste.commons";
import Tooltip from "@hyro-components/Tooltip";
import TriggerPlayIcon from "src/icons/player/TriggerPlayIcon";
import TriggerPauseIcon from "src/icons/player/TriggerPauseIcon";
import TTSPlayer from "src/components/widgets/tts-player/TTSPlayer";
import { useSpeechPlayer } from "src/utils/core/hooks";

const HyroTextField = ({ ...props }) => {
  const theme = useTheme();
  const { InputProps, value, isFieldReadOnlyFromSpec, showCopyButton = true, showPlayerButton = false } = props;
  const isActionPanelVisible = showCopyButton && showPlayerButton && value;
  const onlyCopyButtonVisible = showCopyButton && value;

  const {
    isOpen,
    isPlaying,
    isLoading,
    handlePlayPause,
    closeSpeechPlayer
  } = useSpeechPlayer({ instanceId: props.fieldKey });

  useEffect(() => () => {
    closeSpeechPlayer();
  }, [closeSpeechPlayer]);

  const handleRender = () => {
    if (isActionPanelVisible) {
      return <ActionPanelContainer>
        <FieldCopy type={isFieldReadOnlyFromSpec ? "elevated" : "flat"}
          zIndex={theme.zIndex.drawer + 1}
          value={value}
          iconSize={18}
          buttonSize={24}
          layout={LAYOUTS.ROUNDED}
        />
        {showPlayerButton ? <Tooltip disableInteractive title={isLoading ? "Loading..." : isPlaying ? "Pause utterance" : "Play utterance"}>
          <StyledIconButton
            onClick={() => handlePlayPause({ text: value })}
            size={24}
            type={TYPES.FLAT}
            layout={LAYOUTS.ROUNDED}
            sx={{ backgroundColor: isPlaying ? theme.palette.tertiary[300] : theme.palette.system[0], }}
          >
            {isLoading ? <Stack alignItems="center" justifyContent="center" width={24} height={24}>
              <CircularProgress size={16} sx={{ color: theme.palette.system[700] }} />
            </Stack> : isPlaying ? <TriggerPauseIcon size={18} style={{ flexShrink: 0, width: "18px", height: "18px" }} />
              : <TriggerPlayIcon size={18} style={{ flexShrink: 0, width: "18px", height: "18px" }} />}
          </StyledIconButton>
        </Tooltip> : null}
      </ActionPanelContainer>;
    }
    if (onlyCopyButtonVisible) {
      return <FieldCopy type={isFieldReadOnlyFromSpec ? "elevated" : "flat"}
        zIndex={theme.zIndex.drawer + 1}
        value={value}
        iconSize={16}
        buttonSize={32}
        layout={LAYOUTS.CIRCLE}
        useWrapper
      />;
    }
    return null;
  };

  return <>
    <StyledTextField {...props}
      allowTextCursor={true}
      forceActionPanel={isOpen}
      slotProps={{
        input: {
          ...InputProps,
          endAdornment: (
            <>
              {InputProps?.endAdornment}
              <span className={styledTextFieldClasses.copyIcon}>
                {handleRender()}
              </span>
            </>
          )
        }
      }}
    />
    {isOpen && showPlayerButton && <TTSPlayer instanceId={props.fieldKey} />}
  </>;
};

export default HyroTextField;
